import axios from 'axios';
import * as APJTool from './JSTool';

const HOST_Test =   "http://apj-test.sfduelmobile.com";  //测试地址
const HOST_Release = "https://aplusjapan.co.jp";        //正式地址

function getHost(){
    // if(process.env.NODE_ENV === 'production'){
    //      return window.location.origin;
    // }
    return HOST_Release;
}

//最新新闻
export function getLatestNews(num, onSuccess, onFail) {
    post('/api/client/web/news/latest', {num:num}, onSuccess, onFail);
}

//新闻列表
export function getNewsList(pageIndex, pageNum, onSuccess, onFail) {
    post('/api/client/web/news/list', {pageIndex:pageIndex,pageNum:pageNum}, onSuccess, onFail);
}

//新闻详情
export function getNewsDetail(newsId, onSuccess, onFail) {
    post('/api/client/web/news/detail', { id: parseInt(newsId) }, onSuccess, onFail);
}

//提交反馈
export function submitFeedback(
    name,
    company,
    message,
    email,
    mobile,
    onSuccess, onFail) {

    post('/api/client/contact/add', 
    {
        name,
        company,
        message,
        email,
        mobile: !APJTool.isEmpty(mobile) ? mobile : '0'
     }, 
     onSuccess, onFail);
}

//post 请求
export function post(url, param, onSuccess, onFail) {
    axios.post(getHost() + url, param, {
        headers: {

        },
    }).then(({ data }) => {
        if (100000 == data.code) { //成功
            onSuccess(data.data);
        } else {
            onFail(data.code, data.msg);
        }
    }).catch(function (error) {
        console.log(error);
        onFail(-1000, 'Request fail, try again later.');
    });
}